<template>
    <section class="wrap wrap-large py-12">
        <form
            :class="{ errors: errors }"
            @invalid="invalidate"
            @submit.prevent="submit($event)"
            class="max-w-[730px] at1024:max-w-[1120px] px-[15px] at1024:px-[30px] border w-full mx-auto border-slate-300 at1024:my-8"
            v-if="registrationEnabled"
        >
            <header class="text-center pt-[2em]">
                <h1
                    class="text-[40px] at720:text-4xl my-[30px] at1024:text-[80px]"
                >
                    {{ $t("Registration") }}
                </h1>
            </header>
            <div
                class="box-border mb-[30px] px-[2em] pb-[2em] at1024:px-[4em] at1024:pb-[4em] text-center mx-auto"
            >
                <div class="flex justify-evenly flex-col text-[#3a444f]">
                    <p class="text-[28px] at1024:text-[35px] font-medium leading-[1.2em] mb-[1.1em]">
                        Is your <span class="font-bold">company</span> an
                        existing customer?
                    </p>


                    <p class="font-medium leading-[1.2em] text-[28px] at1024:text-[35px] text-[#97999B] mb-[1.1em] mx-0 mt-0">
                        {{ $t('Please note') }}:
                        <span class="font-bold">{{ $t('we proudly work with industry professionals only') }},</span>
                        and do not sell to end-users. If you categorize yourself
                        as an end-user, give us a call and we can direct you to
                        a re-seller in your area.
                    </p>

                    <div class="grid grid-cols-2 gap-2 mb-[1em]">
                        <button
                            v-for="option in accountOptions"
                            type="button"
                            @click="selectedOption = option.option"
                            :style="
                                selectedOption === option.option
                                    ? {
                                          backgroundColor: '#276FF0',
                                          color: '#ffffff',
                                      }
                                    : null
                            "
                            class="bg-[#fbfbfb] p-4 rounded-sm text-[1em] at1024:text-[1.1em] hover:bg-[#f5f5f5]"
                        >
                            <span
                                ><span class="font-bold">{{
                                    option.option
                                }}</span
                                >, {{ option.extended }}</span
                            >
                        </button>
                    </div>
                    <div class="mt-[1em] mb-[1em]">
                        <span class="font-bold text-[18px]"
                            >{{ $t("Not sure") }}?</span
                        >
                        Give us a call at 800-847-5625 or
                        <a
                            class="border-black border-b-[1px] border-offset-2 hover:text-red hover:border-red"
                            href="mailto:info@seclock.com"
                            >{{ $t("email us") }}</a
                        >.
                    </div>
                </div>

                <div class="text-right flex justify-end">
                    <button
                        :disabled="isDisabled"
                        type="submit"
                        class="btn-white-on-black"
                    >
                        {{ $t("Next") }}
                        <BaseSvg name="icon-chevron-right" />
                    </button>
                </div>
            </div>
        </form>
        <div v-else
            class="flex flex-col items-center justify-center gap-4 mt-40 mb-40 max-w-[1200px] mx-auto"
        >
            <ServiceUnavailableNotice
                title="Service unavailable"
                description="Online registration is down for maintenance and currently unavailable. We estimate that this service will be back online by Tuesday 3/10."
                contact-info="Please contact us at 800-847-5625 to register."
            />
        </div>
    </section>
</template>

<script setup>
import { computed, ref } from "vue";
import { BaseSvg, ServiceUnavailableNotice } from "@/Components";

const props = defineProps(["form", "errors", "registrationEnabled"]);

function invalidate() {
    emit("invalidate");
}

const selectedOption = ref(null);
const accountOptions = ref([
    {
        option: "Yes",
        extended: "my company has an account",
    },
    {
        option: "No",
        extended: "my company does not have an account",
    },
]);

const submit = () => {
    props.form.new_account = selectedOption.value === "No";
    emit("goToNextStep", {
        step:
            selectedOption.value === "Yes"
                ? "WebAccessForm"
                : "RegistrationStep1",
    });
};

const emit = defineEmits(["goToNextStep"]);

const isDisabled = computed(() => selectedOption.value === null);
</script>
